import React, { useEffect, useState } from "react";
import {
  Grid,
  Typography,
  makeStyles,
  Paper,
  Box,
  Button,
  Backdrop,
  CircularProgress,
  useTheme,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import history from "../../utils/HistoryUtils";
import axios from "axios";
import apiConfigs from "../../config/config";
import { useDispatch, useSelector } from "react-redux";
import Notification from "../../components/Notification/Notification";
import AsigneeStaffEvent from "./AsigneeStaffEvent";
import AlertDialog from "../../components/Alert/AlertDialog";
import { activeOrDeactiveStaff } from "../../store/action";
import Loading from "../../components/Loading/Loading";

const useStyle = makeStyles((theme) => ({
  root: {
    width: "100%",
    overflowX: "auto",
    padding: 20,
    background: theme.palette.background.main
  },
  btnContainer: {
    "& > *": {
      marginLeft: theme.spacing(1),
      "& svg": {
        width: 20,
        height: "auto",
      },
    },
  },

  activeBtn: {
    backgroundColor: theme.palette.secondary.light,
    '&:hover': { backgroundColor: '#ffc1d3' }
  },
  deactiveBtn: {
    backgroundColor: theme.palette.grey[500],
    '&:hover': { backgroundColor: theme.palette.grey[700] }
  }
}));

const DetailStaff = ({ match }) => {
  const theme = useTheme();
  const classes = useStyle();
  const dispatch = useDispatch();
  const user_id = match.params.id;
  const [Id, setId] = useState(false);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [staffNotify, setStaffNotify] = useState(false);
  const { staffDeleteSuccess, staffDeleteError } = useSelector(
    (state) => state.staff
  );
  const staffDetail = JSON.parse(localStorage.getItem("staffDetail"));
  const loginUserInfo = JSON.parse(window.localStorage.getItem("loginUserInfo"));
  const [activeOpen, setActiveOpen] = useState(false);
  const [deActiveOpen, setDeActiveOpen] = useState(false);
  const [openAsigneeStaff, setOpenAsigneeStaff] = useState(false);
  const roleName = localStorage.getItem('role').replace(/['"]+/g, "");
  const upadateLink = () => {
    history.push(`update`);
  };
  const changepasswordLink = () => {
    history.push(`changepassword`);
  }
  const canModifyStaffStatus =
    (staffDetail === "Admin" || loginUserInfo?.role === "ORGANIZATION" || loginUserInfo?.is_smt === "Yes") ||
    (loginUserInfo?.role === "STAFF" && loginUserInfo?.permissions?.some(p => p.toLowerCase() === "staff-update")) ||
    (loginUserInfo?.role !== "STAFF");

  const getSingleStaff = async () => {
    const loggedInUser = localStorage.getItem("token").replace(/['"]+/g, "");
    setLoading(true);
    await axios
      .get(`${apiConfigs.API_URL}api/organization/user/get-user/${user_id}`, {
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${loggedInUser}`,
        },
      })
      .then((response) => {
        setItems(response.data.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("error.message", error.message);
        setLoading(false);
      });
  };

  const deleteStaffItem = (id) => {
    handleClickOpenAsigneeStaff();
    setId(id);
  };

  const handleClickOpenAsigneeStaff = () => {
    setOpenAsigneeStaff(true);
  }

  const handleClose = () => {
    setOpenAsigneeStaff(false)
  }


  const backPage = () => {
    history.push("/admin/staff");
  };

  const aActiveClose = () => {
    setActiveOpen(false);
  };
  const dActiveClose = () => {
    setDeActiveOpen(false);
  };
  const alertActiveResponse = async (id) => {
    await dispatch(activeOrDeactiveStaff(id, 1));
    getSingleStaff();
    setStaffNotify(true);
  };
  const alertDeActiveResponse = async (id) => {
    await dispatch(activeOrDeactiveStaff(id, 0));
    getSingleStaff();
    setStaffNotify(true);
  };

  const onHandlActive = () => {
    setActiveOpen(true);
  };

  const onHandlDeActive = () => {
    setDeActiveOpen(true);
  };


  useEffect(() => {
    getSingleStaff();
  }, [user_id]);


  const canUpdate =
    (staffDetail === "Admin" ||
      loginUserInfo?.role === "ORGANIZATION" ||
      loginUserInfo?.is_smt === "Yes") ||
    (loginUserInfo?.role === "STAFF" &&
      loginUserInfo?.permissions?.some(p => p.toLowerCase() === "staff-update")) ||
    (loginUserInfo?.role !== "STAFF" && loginUserInfo?.role !== "ORGANIZATION" && loginUserInfo?.role !== "ADMIN");

  return (
    <>
      {loading && <Loading open={loading} />}

      {staffNotify && staffDeleteSuccess?.message && (
        <Notification data="Staff member deleted successfully" status="success" />
      )}

      {staffNotify && staffDeleteError?.message && (
        <Notification data={staffDeleteError?.message} status="error" />
      )}

      <Paper className={`${classes.root} mb-6`} elevation={3}>
        <Grid container spacing={2} px={3} pb={3}>
          {/* Staff Info Grid */}
          {[
            { label: "First Name", value: items.first_name },
            { label: "Last Name", value: items.last_name },
            { label: "Email Address", value: items.email },
            { label: "Contact Number", value: items.contact_number },
            { label: "Role", value: items.role_name || "-" },
            { label: "Designation", value: items.designation_name || "-" },
          ].map((field, idx) => (
            <Grid item xs={12} sm={6} lg={4} key={idx}>
              <Box mb={1}>
                <Typography style={{ color: theme.palette.listItem }}>
                  {field.label}
                </Typography>
                <Typography variant="h6" fontWeight={500}>
                  {field.value}
                </Typography>
              </Box>
            </Grid>
          ))}

          <Grid item xs={12}>
            <Box display="flex" justifyContent="flex-end" className={classes.btnContainer}>
              <Button color="primary" variant="outlined" onClick={backPage}>Back</Button>
              {(roleName === 'ORGANIZATION' || (loginUserInfo?.role === "STAFF" &&
                loginUserInfo?.permissions?.some(p => p.toLowerCase() === "staff-update")) || (loginUserInfo?.role !== "STAFF")) && (
                  <Button variant="contained" color="primary" startIcon={<EditIcon />} onClick={changepasswordLink}>
                    Change Password
                  </Button>
                )}

              {/* {(loginUserInfo?.role === "STAFF" &&
                loginUserInfo?.permissions?.some(p => p.toLowerCase() === "staff-update")) || (loginUserInfo?.role !== "STAFF" || staffDetail !== "Booking" && staffDetail !== "Finance") && (
                  <Button variant="contained" color="primary" startIcon={<EditIcon />} onClick={upadateLink}>
                    Edit
                  </Button>
                )} */}
              {
                (
                  (
                    loginUserInfo?.role !== "STAFF" ||
                    loginUserInfo?.permissions?.some(
                      p => p.toLowerCase() === "staff-update"
                    )
                  )
                  &&
                  (staffDetail !== "Booking" && staffDetail !== "Finance")
                ) && (
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<EditIcon />}
                    onClick={upadateLink}
                  >
                    Edit
                  </Button>
                )
              }



              {((staffDetail === "Admin" || loginUserInfo?.role === "ORGANIZATION") || (loginUserInfo?.role === "STAFF" &&
                loginUserInfo?.permissions?.some(p => p.toLowerCase() === "staff-delete")) || (loginUserInfo?.role !== "STAFF")) && (
                  <Button variant="contained" color="secondary" startIcon={<DeleteIcon />} onClick={() => deleteStaffItem(items.id)}>
                    Delete
                  </Button>
                )}

              {(
                (staffDetail === "Admin" || loginUserInfo?.role === "ORGANIZATION" || loginUserInfo?.is_smt === "Yes" && (loginUserInfo?.role === "STAFF" &&
                  loginUserInfo?.permissions?.some(p => p.toLowerCase() === "staff-update")) || (loginUserInfo?.role !== "STAFF"))
                &&
                (items.deleted === 1)
              ) && (
                  <Button variant="contained" color="warning" onClick={() => onHandlDeActive(items.id)} className={classes.deactiveBtn}>
                    Deactivate
                  </Button>
                )}

              {((staffDetail === "Admin" || loginUserInfo?.role === "ORGANIZATION" || loginUserInfo?.is_smt === "Yes" && (loginUserInfo?.role === "STAFF" &&
                loginUserInfo?.permissions?.some(p => p.toLowerCase() === "staff-update")) || (loginUserInfo?.role !== "STAFF")) && (items.deleted === 0)) && (
                  <Button variant="contained" color="success" onClick={() => onHandlActive(items.id)} className={classes.activeBtn}>
                    Activate
                  </Button>
                )}
            </Box>
          </Grid>
        </Grid>
      </Paper>

      <AsigneeStaffEvent
        open={openAsigneeStaff}
        handleClose={handleClose}
        asigneeId={items.id}
        asigneeName={items.first_name + ' ' + items.last_name}
      />

      <AlertDialog
        id={items.id}
        open={activeOpen}
        close={aActiveClose}
        response={alertActiveResponse}
        title="Active Staff Member"
        description="Are you sure you want to active this user?"
        buttonName="Active"
      />

      <AlertDialog
        id={items.id}
        open={deActiveOpen}
        close={dActiveClose}
        response={alertDeActiveResponse}
        title="Deactive Staff Member"
        description="Are you sure you want to deactive this user?"
        buttonName="Deactive"
      />
    </>
  );
};

export default DetailStaff;
